import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { getAlgoListDataCachedSelectedDay } from '../../../../stores/algos-list/getters';
import ErrorCount from './ErrorCount';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const CellEntryErrors = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;

  const { _id = '' } = original;

  const entryErrorCount = useSelector((state) => {
    const { entryErrorCount = 0 } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return entryErrorCount;
  });

  return (
    <div className={classes.root}>
      <ErrorCount value={entryErrorCount} />
    </div>
  );
};

export default CellEntryErrors;
